export async function fetchWithAuth(url, options = {}) {
    const token = localStorage.getItem('token');
   console.log(token);
    const res = await fetch(url, {
      ...options,
      headers: {
        ...(options.headers || {}),
        Authorization: `Bearer ${token}`,
      },
    });
  
    if (res.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
      return null;
    }
  
    return res;
  }
  